import axios from 'axios';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.menu_api.menu_category_types;

// Helper function to configure the Axios instance with auth interceptor
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  }
}));


// Function to fetch all menu category types
export const getAllMenuCategoryTypes = async () => {
  return retryWithBackoff(() => api.get('/GetAllMenuCategoryTypes'));
};